<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPlus_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M8.8 3.475a.8.8 0 0 0-1.6 0V7.2H3.475a.8.8 0 0 0 0 1.6H7.2v3.725a.8.8 0 1 0 1.6 0V8.8h3.725a.8.8 0 1 0 0-1.6H8.8V3.475Z"
        clip-rule="evenodd"
    />
</svg>
